<!--
  ~ Copyright (c) 2019
  ~    Reliant Business Valuation, LLC - http://reliantvalue.com
  ~    Author: Kirill Vizniuk - kirill@internalvaluation.com
  ~
  ~ Licensed under the Apache License, Version 2.0 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~ http://www.apache.org/licenses/LICENSE-2.0
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" BASIS,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<div class="content-wrapper">
  <div class="content">
    <div class="history-record" *ngFor="let r of history | orderBy : ['DATE']">
      <div class="date">
        {{r.DATE | date: 'MMM dd, yy, hh:mm:ss a'}}
      </div>

      <div class="transition" *ngIf="getStageById(r.P_SID)">
        <fa name="fa fa-long-arrow-right"></fa>
        <div class="stage to">{{getStageById(r.P_SID).NAME}}</div>
      </div>

      <ng-container *ngIf="r.USER">
        <div class="title">By:</div>
        <div class="user">
          <ngx-avatar [name]="r.USER.FIRST_NAME+' '+r.USER.LAST_NAME" size="20"></ngx-avatar>
          <div class="user-name">{{r.USER.FIRST_NAME+' '+r.USER.LAST_NAME}}</div>
        </div>
      </ng-container>

      <ng-container *ngIf="!r.USER">
        <div class="title">By:</div>
        <div class="user">
          <ngx-avatar name="System" size="20"></ngx-avatar>
          <div class="user-name">System</div>
        </div>
      </ng-container>

      <ng-container *ngIf="r.ASSIGNEE?.FIRST_NAME && r.ASSIGNEE?.LAST_NAME">
        <div class="title">Assignee:</div>
        <div class="user">
          <ngx-avatar [name]="r.ASSIGNEE?.FIRST_NAME+' '+r.ASSIGNEE?.LAST_NAME" size="20"></ngx-avatar>
          <div class="user-name">{{r.ASSIGNEE?.FIRST_NAME+' '+r.ASSIGNEE?.LAST_NAME}}</div>
        </div>
      </ng-container>

      <ng-container *ngIf="r.NOTE">
        <div class="title">Notes:</div>
        <div class="note">{{r.NOTE}}</div>
      </ng-container>
    </div>

    <div class="button-wrapper d-flex align-items-center" *ngIf="stage.ID === 'ELST'">
      <div style="margin-top: -1px;">
        <custom-download-preview [previewOnly]="true" [report]="currentReport"></custom-download-preview>
      </div>

      <button class="btn btn-rbv" (click)="onDownloadPdf()"
        [disabled]="isLoadingPreview">
        <span class="loading-icon-small" *ngIf="isLoadingPreview"></span>
        Download
      </button>
    </div>

  </div>
</div>
